import Api from "utils/api/Api";


export const getEpisode = (params)=>Api.get(`/api/userBook/episode/${params?.queryKey[1]}`);

export const getUserBook = (params)=>{
    if(params?.queryKey[1]===undefined)return false;
    return Api.get(`/api/userBook/${params?.queryKey[1]}`);
};